import { IoEllipsisHorizontal, IoEllipsisVertical } from "react-icons/io5"
import { isIOS } from "../lib/platform"

export function TelegramOpenInBrowserBanner() {
  const ios = isIOS()
  const Icon = ios ? IoEllipsisHorizontal : IoEllipsisVertical
  const title = ios
    ? "Откройте в Safari, чтобы установить приложение"
    : "Откройте в браузере, чтобы установить приложение"
  const hintPrefix = "Нажмите "
  const hintSuffix = ios ? " внизу справа → «Открыть в Safari»" : " вверху справа → «Открыть в браузере»"

  return (
    <div className="flex items-center gap-s px-m py-s bg-primary/10">
      {/* <div className="flex size-8 items-center justify-center rounded-md bg-background"> */}
      {/*   <Icon className="size-5" /> */}
      {/* </div> */}
      <div className="flex-1 text-sm leading-tight min-w-0">
        <div className="text-secondary truncate whitespace-nowrap">{title}</div>
        <div className="text-muted-foreground truncate whitespace-nowrap">
          {hintPrefix}
          <Icon className="inline align-[-2px] text-secondary text-base" />
          {hintSuffix}
        </div>
      </div>
    </div>
  )
}
